// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__13D1m","author":"Table_author__1Bah0","authorImage":"Table_authorImage__1s7h8","unreadRow":"Table_unreadRow__5510a"};